import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Project,
  Resource,
  RetrieveResourceProjectsQuery,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projects: Identifiable<Project>[];
  cursor: number;
  canRetrieveNextResourceProjects: boolean;
  retrieveResourceProjects(
    request: Boundaries["retrieveResourceProjects"]["request"],
  ): void;
}

function useRetrieveResourceProjects(
  resource: Identifiable<Resource>,
  query: RetrieveResourceProjectsQuery,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveResourceProjectsRequestPending(resource, query),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveResourceProjectsRequestSuccess(resource, query),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveResourceProjectsRequestFailure(resource, query),
    ),
    projects: useSelector(() => selector.getResourceProjects(resource, query)),
    cursor: useSelector(() =>
      selector.getResourceProjectsCursor(resource, query),
    ),
    canRetrieveNextResourceProjects: useSelector(() =>
      selector.canRetrieveNextResourceProjects(resource, query),
    ),
    retrieveResourceProjects: core.retrieveResourceProjects,
  };
}

export { useRetrieveResourceProjects };
